var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Platform } from "react-native";
import ReactNativeConfig from "react-native-config";
import { CONFIG_DEMO } from "./app.config.demo";
import { CONFIG_DEV } from "./app.config.dev";
import { CONFIG_LOCAL } from "./app.config.local";
import { CONFIG_LOCAL_DEMO } from "./app.config.local.demo";
import { CONFIG_LOCAL_DEV } from "./app.config.local.dev";
import { CONFIG_LOCAL_PROD } from "./app.config.local.prod";
import { CONFIG_LOCAL_STAG } from "./app.config.local.stag";
import { CONFIG_PROD } from "./app.config.prod";
import { CONFIG_STAG } from "./app.config.stag";
import { EEnvironment } from "./app.config.types";
// For iOS and Android we need to use the custom config from react-native-config
var ENV_VARIABLES = Platform.OS === "ios" || Platform.OS === "android"
    ? ReactNativeConfig
    : process.env;
var PRODUCT = ENV_VARIABLES.REACT_APP_PRODUCT;
var ENVIRONMENT = ENV_VARIABLES.REACT_APP_ENV || EEnvironment.Prod;
var RESOLVED_CONFIG = (function () {
    if (!PRODUCT) {
        throw new Error("No product defined");
    }
    if (ENV_VARIABLES.REACT_APP_ENV_LOCAL) {
        // Which local Docker environment the APIs run in, e.g. `dev` for
        // `yarn start:dashboard:local:dev` (local APIs on the dev database). The
        // plain `start:...:local` scripts pass 1, which falls through to CONFIG_LOCAL.
        var LOCAL_CONFIGS = {
            demo: CONFIG_LOCAL_DEMO,
            dev: CONFIG_LOCAL_DEV,
            prod: CONFIG_LOCAL_PROD,
            stag: CONFIG_LOCAL_STAG,
        };
        return __assign(__assign({ PRODUCT: PRODUCT }, CONFIG_PROD), (LOCAL_CONFIGS[ENV_VARIABLES.REACT_APP_ENV_LOCAL] || CONFIG_LOCAL));
    }
    if (ENVIRONMENT === EEnvironment.Dev) {
        return __assign(__assign({ PRODUCT: PRODUCT }, CONFIG_PROD), CONFIG_DEV);
    }
    if (ENVIRONMENT === EEnvironment.Stag) {
        return __assign(__assign({ PRODUCT: PRODUCT }, CONFIG_PROD), CONFIG_STAG);
    }
    if (ENVIRONMENT === EEnvironment.Demo) {
        return __assign(__assign({ PRODUCT: PRODUCT }, CONFIG_PROD), CONFIG_DEMO);
    }
    return __assign({ PRODUCT: PRODUCT }, CONFIG_PROD);
})();
export var CONFIG = __assign(__assign({}, RESOLVED_CONFIG), { 
    // Sentry environments are lowercase everywhere in Rentio, because that is what the APIs send:
    // api-next's RENTIO_ENVIRONMENT and legacy's NODE_ENV are both `dev` | `stag` | `demo` | `prod`.
    // EEnvironment carries the same names in uppercase and is load-bearing - url.utils, property.utils
    // and the feature flags all switch on it - so the enum stays as it is and only the value handed to
    // Sentry.init is normalized. Without this, following one incident across the stack means querying
    // `environment:PROD` for the web apps and `environment:prod` for the APIs that served them.
    SENTRY_ENVIRONMENT: RESOLVED_CONFIG.ENVIRONMENT.toLowerCase() });
